/**
 * Whether the main navigation shows the Customers tab: the account has the
 * module on, and the person can see customers at the store in view
 * (customers:read, or an account or system admin).
 */
import { canReadCustomers } from './customersAccess';
import { useCustomersOn } from './customersQueries';

export function useCustomersTab(accountId: string | null | undefined, permissions: readonly string[]): boolean {
  const allowed = canReadCustomers(permissions);
  const { on } = useCustomersOn(accountId && accountId !== 'ALL' ? accountId : null, { enabled: allowed });
  return allowed && on;
}
